import { createContext, useContext, useEffect, useState } from "react";

export const CONTENT = {
  en: {
    navLinks: [
      { label: "Home", href: "#home" },
      { label: "About", href: "#about" },
      { label: "Products", href: "#products" },
      { label: "Contact", href: "#contact" },
    ],
    navOrder: "Order Now",
    heroEyebrow: "Official Lucky & Bestway Cement Distributor · Islamabad & Rawalpindi",
    heroLines: ["Pakistan\u2019s most", "trusted", "cement supplier."],
    heroSub: "Get your cement at wholesale rates.",
    heroCta: "Order on WhatsApp",
    heroPara:
      "We supply Lucky Cement and Bestway Cement in bulk across Islamabad and Rawalpindi — directly to dealers, builders, and large-scale construction projects.",
    heroBadges: ["Bulk Orders Welcome", "Same-day Dispatch Available"],
    marqueePre: "Supplying to",
    marqueeAccent: "Pakistan\u2019s finest",
    marqueePost: "builders",
    clients: [
      { name: "DHA Islamabad", sub: "Phase 2 & 5" },
      { name: "Bahria Town", sub: "Rawalpindi" },
      { name: "PWD Housing", sub: "Islamabad" },
      { name: "F-Sector Projects", sub: "Federal Capital" },
      { name: "G-13 Development", sub: "Islamabad" },
      { name: "Gulberg Residencia", sub: "Islamabad" },
      { name: "CBR Town", sub: "Rawalpindi" },
    ],
    statsLabels: ["Clients Served", "Premium Brands", "Delivery Available"],
    sameDay: "Same Day",
    whyPre: "Why builders",
    whyAccent: "choose us.",
    whyCards: [
      {
        num: "01",
        title: "Bulk Supply",
        desc: "From 100 bags to full truckloads — we handle orders of any scale for residential and commercial projects.",
        bullets: ["100+ bags minimum order", "Truckload deliveries available", "Lucky Cement & Bestway Cement in stock"],
      },
      {
        num: "02",
        title: "Fast Delivery",
        desc: "Same-day and next-day dispatch across Islamabad and Rawalpindi. We know your timeline matters.",
        bullets: ["Same-day dispatch", "Isb & Rwp coverage", "Real-time order updates"],
      },
      {
        num: "03",
        title: "Lab Tested",
        desc: "Both Lucky Supreme and Bestway OPC are officially tested and exceed Pakistan Standard PS-232-2008 requirements on every metric — strength, setting time, and fineness. Lab reports available on request.",
        bullets: [
          "Lucky Supreme: 60.20 MPa at 28 days (required 53 MPa)",
          "Bestway OPC: 53.80 MPa at 28 days (required 53 MPa)",
          "Official lab reports available on request",
        ],
      },
    ],
    brandsPre: "The Brands",
    brandsAccent: "We Carry.",
    brandsItems: [
      {
        key: "lucky",
        name: "Lucky Cement",
        desc: "Pakistan's largest cement producer, founded in 1993 and part of the Yunus Brothers Group. With plants in Karachi and Pezu and a 15.3 million ton annual capacity, Lucky Cement supplies local and international markets across South Asia, Africa, and the Middle East.",
        tag: "Official Distributor for Islamabad & Rawalpindi",
      },
      {
        key: "bestway",
        name: "Bestway Cement",
        desc: "A subsidiary of Bestway Group (UK), founded in 1993 and headquartered in Islamabad. Bestway is one of Pakistan's most recognized cement manufacturers, trusted by contractors and builders nationwide for consistent quality and reliability.",
        tag: "Wholesale Supplier for Islamabad & Rawalpindi",
      },
    ],
    productsPre: "Our Cement",
    productsAccent: "Products",
    productsSub: "Two trusted brands. Lab-tested on every batch.",
    viewReport: "View Full Report",
    productsFootnote: "Minimum order: 100 bags · Same-day delivery across Islamabad & Rawalpindi",
    productItems: [
      {
        key: "lucky",
        label: "Lucky Cement",
        name: "Lucky Supreme",
        tags: ["Grade-53 | OPC", "PS-232-2008 Certified"],
        desc: "Pakistan's largest cement producer. Lucky Supreme Grade-53 is engineered for high-strength structural applications — residential, commercial, and infrastructure.",
        statLabels: ["28-Day Strength", "3-Day Strength", "Fineness / Blaine"],
        note: "Tested by Lucky Cement Ltd. Q.C — Pezu Plant",
      },
      {
        key: "bestway",
        label: "Bestway Cement",
        name: "Bestway OPC",
        tags: ["OPC | Hattar Plant", "PS-232-2008 Certified"],
        desc: "Trusted nationwide manufacturer. Bestway OPC delivers consistent strength and workability — the reliable choice for contractors and builders across Pakistan.",
        statLabels: ["28-Day Strength", "3-Day Strength", "Fineness / Blaine"],
        note: "Tested by Bestway Cement Ltd. Hattar Q.C",
      },
    ],
    labPre: "Lab",
    labAccent: "Results.",
    labSub: "Both products independently tested and certified against Pakistan Standard PS-232-2008. Every metric. Every batch.",
    labHeaders: ["Test", "PS-232-2008 Requirement", "Lucky Supreme", "Bestway OPC"],
    labRows: [
      { test: "Compressive Strength — 3 Day", req: "Min. 27 MPa" },
      { test: "Compressive Strength — 7 Day", req: "Min. 37 MPa" },
      { test: "Compressive Strength — 28 Day", req: "Min. 53 MPa" },
      { test: "Initial Setting Time", req: "Min. 30 min" },
      { test: "Final Setting Time", req: "Max. 600 min" },
      { test: "Fineness (Blaine)", req: "Min. 229 m²/kg" },
      { test: "Soundness (Le-Chatlier)", req: "Max. 10mm" },
    ],
    labCaptions: [
      "Lucky Supreme: Test Certificate issued by Lucky Cement Limited, Dy. General Manager (Q.C), Pezu Plant",
      "Bestway OPC: Cement Test Report issued by Bestway Cement Limited, HOD QC, Hattar Plant",
    ],
    servePre: "Who We",
    serveAccent: "Serve.",
    serveSub: "From individual builds to large-scale developments — we supply anyone who builds.",
    servePills: ["Contractors", "Builders", "Housing Societies", "Residential Projects", "Commercial Buildings", "Infrastructure Projects", "Retail Dealers"],
    stepsPre: "How to",
    stepsAccent: "Order.",
    stepsSub: "Simple process. Same-day delivery. No hassle.",
    steps: [
      { title: "Contact Ghauri Traders", desc: "Reach out on WhatsApp with your requirement." },
      { title: "Share Required Quantity", desc: "Tell us how many bags you need (minimum 100)." },
      { title: "Confirm Product", desc: "Choose Lucky Supreme or Bestway OPC." },
      { title: "Schedule Delivery", desc: "We confirm your delivery slot." },
      { title: "On-Time Supply", desc: "Cement delivered to your doorstep, same day." },
    ],
    stepsCta: "Start Your Order",
    contactEyebrow: "Ready to order?",
    contactPre: "Get Lucky & Bestway Cement",
    contactAccent: "delivered today.",
    contactBody: "Talk to us directly on WhatsApp. Tell us your requirement and we'll get back to you within minutes.",
    contactCta: "Order on WhatsApp",
    contactVisit: "Visit Us",
    contactHours: "Hours",
    contactWrite: "Write to Us",
    contactAddress: "07, Street 12D, Jinnah Garden, Islamabad, 44000, Pakistan",
    contactHoursValue: "Monday–Saturday, 8:00 AM – 6:00 PM",
    footer1: "© 2026 Ghauri Traders. Official Lucky & Bestway Cement Distributor — Islamabad & Rawalpindi.",
    footer2: "Built for Pakistan\u2019s builders.",
    seoLinks: [
      { label: "Lucky Cement Price", href: "/lucky-cement-price" },
      { label: "Bestway Cement Islamabad", href: "/bestway-cement-islamabad" },
    ],
    backHome: "← Back to Home",
    viewLabReport: "View Lab Report ↗",
    seo: {
      lucky: {
        metaTitle: "Lucky Cement Price in Islamabad & Rawalpindi | Ghauri Traders",
        metaDesc: "Today's Lucky Cement wholesale price in Islamabad & Rawalpindi. Official distributor of Lucky Supreme Grade-53 OPC. Min order 100 bags, same-day delivery. Get a live quote on WhatsApp.",
        eyebrow: "Official Lucky Cement Distributor",
        h1Pre: "Lucky Cement",
        h1Accent: "price in Islamabad & Rawalpindi.",
        paragraphs: [
          "Looking for today's Lucky Cement price in Islamabad or Rawalpindi? Cement rates in Pakistan shift with the market, so we quote live wholesale prices directly on WhatsApp — no outdated price lists.",
          "As an official Lucky Cement distributor for Islamabad & Rawalpindi, Ghauri Traders supplies Lucky Supreme (Grade-53 OPC) at wholesale rates with same-day dispatch. Minimum order is 100 bags, and full truckload deliveries are available for larger projects.",
        ],
        cards: [
          { title: "Today's Wholesale Rate", desc: "Message us on WhatsApp with your quantity and get the current Lucky Supreme rate within minutes." },
          { title: "Lab-Tested Quality", desc: "Every batch certified against PS-232-2008: 60.20 MPa at 28 days, 344 m²/kg fineness. Test certificate available on request." },
          { title: "Same-Day Delivery", desc: "Dispatch across Islamabad & Rawalpindi — directly to your site, dealer shop, or housing society." },
        ],
        cta: "Get Today's Price on WhatsApp",
        reportUrl: "/assets/lucky-supreme-lab.pdf",
      },
      bestway: {
        metaTitle: "Bestway Cement Islamabad — Wholesale Supplier | Ghauri Traders",
        metaDesc: "Bestway Cement wholesale supplier in Islamabad & Rawalpindi. Bestway OPC at wholesale rates, lab-tested at Hattar plant. Min order 100 bags, same-day dispatch. Quote on WhatsApp.",
        eyebrow: "Bestway Cement Wholesale Supplier",
        h1Pre: "Bestway Cement",
        h1Accent: "in Islamabad — wholesale supply.",
        paragraphs: [
          "Ghauri Traders is a wholesale supplier of Bestway OPC cement for Islamabad and Rawalpindi, with every batch lab-tested at Bestway's Hattar plant against Pakistan Standard PS-232-2008.",
          "Bestway OPC delivers 53.80 MPa at 28 days (PS-232-2008 requirement: 53 MPa) with 318 m²/kg fineness — a reliable choice for contractors, builders, and housing projects. Minimum order 100 bags, with same-day dispatch available across the twin cities.",
        ],
        cards: [
          { title: "Wholesale Rates", desc: "Bulk pricing for dealers, builders, and housing societies — quoted live on WhatsApp." },
          { title: "Certified Batches", desc: "53.80 MPa 28-day strength, certified against PS-232-2008. Hattar Q.C test report available on request." },
          { title: "Fast Dispatch", desc: "Same-day and next-day delivery across Islamabad & Rawalpindi." },
        ],
        cta: "Get a Wholesale Quote on WhatsApp",
        reportUrl: "/assets/bestway-lab.jpg",
      },
    },
  },
  ur: {
    navLinks: [
      { label: "ہوم", href: "#home" },
      { label: "تعارف", href: "#about" },
      { label: "مصنوعات", href: "#products" },
      { label: "رابطہ", href: "#contact" },
    ],
    navOrder: "آرڈر کریں",
    heroEyebrow: "لکی اور بیسٹ وے سیمنٹ کے آفیشل ڈسٹریبیوٹر · اسلام آباد اور راولپنڈی",
    heroLines: ["پاکستان کا سب سے", "قابلِ اعتماد", "سیمنٹ سپلائر۔"],
    heroSub: "ہول سیل ریٹس پر سیمنٹ حاصل کریں۔",
    heroCta: "واٹس ایپ پر آرڈر کریں",
    heroPara:
      "ہم اسلام آباد اور راولپنڈی بھر میں لکی سیمنٹ اور بیسٹ وے سیمنٹ بلک میں فراہم کرتے ہیں — براہ راست ڈیلرز، بلڈرز اور بڑے تعمیراتی منصوبوں تک۔",
    heroBadges: ["بلک آرڈرز کا خیرمقدم", "اسی دن ترسیل دستیاب"],
    marqueePre: "",
    marqueeAccent: "پاکستان کے بہترین",
    marqueePost: "بلڈرز کی سپلائی",
    clients: [
      { name: "DHA Islamabad", sub: "فیز 2 اور 5" },
      { name: "Bahria Town", sub: "راولپنڈی" },
      { name: "PWD Housing", sub: "اسلام آباد" },
      { name: "F-Sector Projects", sub: "وفاقی دارالحکومت" },
      { name: "G-13 Development", sub: "اسلام آباد" },
      { name: "Gulberg Residencia", sub: "اسلام آباد" },
      { name: "CBR Town", sub: "راولپنڈی" },
    ],
    statsLabels: ["مطمئن کلائنٹس", "پریمیم برانڈز", "ترسیل دستیاب"],
    sameDay: "اسی دن",
    whyPre: "بلڈرز ہمیں کیوں",
    whyAccent: "منتخب کرتے ہیں۔",
    whyCards: [
      {
        num: "01",
        title: "بلک سپلائی",
        desc: "100 بوروں سے لے کر پورے ٹرک لوڈ تک — ہم رہائشی اور کمرشل منصوبوں کے لیے ہر پیمانے کے آرڈرز سنبھالتے ہیں۔",
        bullets: ["کم از کم آرڈر 100+ بورے", "ٹرک لوڈ ڈیلیوری دستیاب", "لکی اور بیسٹ وے سیمنٹ اسٹاک میں موجود"],
      },
      {
        num: "02",
        title: "تیز ترسیل",
        desc: "اسلام آباد اور راولپنڈی بھر میں اسی دن یا اگلے دن ترسیل۔ ہم جانتے ہیں کہ آپ کا وقت اہم ہے۔",
        bullets: ["اسی دن ترسیل", "اسلام آباد و راولپنڈی کوریج", "آرڈر کی فوری اپڈیٹس"],
      },
      {
        num: "03",
        title: "لیب ٹیسٹڈ",
        desc: "لکی سپریم اور بیسٹ وے OPC دونوں باقاعدہ ٹیسٹ شدہ ہیں اور پاکستان اسٹینڈرڈ PS-232-2008 کے تقاضوں سے ہر پیمانے پر بہتر ہیں — مضبوطی، سیٹنگ ٹائم اور باریکی۔ لیب رپورٹس درخواست پر دستیاب ہیں۔",
        bullets: [
          "لکی سپریم: 28 دن میں 60.20 MPa (مطلوبہ 53 MPa)",
          "بیسٹ وے OPC: 28 دن میں 53.80 MPa (مطلوبہ 53 MPa)",
          "آفیشل لیب رپورٹس درخواست پر دستیاب",
        ],
      },
    ],
    brandsPre: "ہمارے",
    brandsAccent: "برانڈز۔",
    brandsItems: [
      {
        key: "lucky",
        name: "لکی سیمنٹ",
        desc: "پاکستان کا سب سے بڑا سیمنٹ پروڈیوسر، 1993 میں قائم اور یونس برادرز گروپ کا حصہ۔ کراچی اور پيزو میں پلانٹس اور 15.3 ملین ٹن سالانہ پیداواری صلاحیت کے ساتھ لکی سیمنٹ جنوبی ایشیاء، افریقہ اور مشرقِ وسطیٰ کی منڈیوں کو سپلائی کرتا ہے۔",
        tag: "اسلام آباد اور راولپنڈی کے لیے آفیشل ڈسٹریبیوٹر",
      },
      {
        key: "bestway",
        name: "بیسٹ وے سیمنٹ",
        desc: "بیسٹ وے گروپ (یوکے) کا ذیلی ادارہ، 1993 میں قائم اور اسلام آباد میں ہیڈکوارٹر۔ بیسٹ وے پاکستان کے معروف سیمنٹ مینوفیکچررز میں سے ایک ہے، جس پر ملک بھر کے کنٹریکٹرز اور بلڈرز مستقل معیار کے لیے اعتماد کرتے ہیں۔",
        tag: "اسلام آباد اور راولپنڈی کے لیے ہول سیل سپلائر",
      },
    ],
    productsPre: "ہماری سیمنٹ",
    productsAccent: "مصنوعات",
    productsSub: "دو قابلِ اعتماد برانڈز۔ ہر بیچ لیب ٹیسٹڈ۔",
    viewReport: "مکمل رپورٹ دیکھیں",
    productsFootnote: "کم از کم آرڈر: 100 بورے · اسلام آباد اور راولپنڈی میں اسی دن ڈیلیوری",
    productItems: [
      {
        key: "lucky",
        label: "لکی سیمنٹ",
        name: "لکی سپریم",
        tags: ["گریڈ-53 | OPC", "PS-232-2008 سرٹیفائیڈ"],
        desc: "پاکستان کا سب سے بڑا سیمنٹ پروڈیوسر۔ لکی سپریم گریڈ-53 ہائی اسٹرینتھ سٹرکچرل کاموں کے لیے تیار کیا گیا ہے — رہائشی، کمرشل اور انفراسٹرکچر۔",
        statLabels: ["28 دن کی مضبوطی", "3 دن کی مضبوطی", "باریکی / بلين"],
        note: "لکی سیمنٹ لمیٹڈ Q.C — پيزو پلانٹ کی جانب سے ٹیسٹ شدہ",
      },
      {
        key: "bestway",
        label: "بیسٹ وے سیمنٹ",
        name: "بیسٹ وے OPC",
        tags: ["OPC | ہٹار پلانٹ", "PS-232-2008 سرٹیفائیڈ"],
        desc: "ملک بھر میں قابلِ اعتماد مینوفیکچرر۔ بیسٹ وے OPC مستقل مضبوطی اور بہترین ورک ایبلیٹی فراہم کرتا ہے — پاکستان بھر کے کنٹریکٹرز اور بلڈرز کا قابلِ اعتماد انتخاب۔",
        statLabels: ["28 دن کی مضبوطی", "3 دن کی مضبوطی", "باریکی / بلين"],
        note: "بیسٹ وے سیمنٹ لمیٹڈ ہٹار Q.C کی جانب سے ٹیسٹ شدہ",
      },
    ],
    labPre: "لیب",
    labAccent: "رزلٹس۔",
    labSub: "دونوں مصنوعات پاکستان اسٹینڈرڈ PS-232-2008 کے تحت آزادانہ طور پر ٹیسٹ اور سرٹیفائیڈ ہیں۔ ہر پیمانہ۔ ہر بیچ۔",
    labHeaders: ["ٹیسٹ", "PS-232-2008 تقاضہ", "لکی سپریم", "بیسٹ وے OPC"],
    labRows: [
      { test: "کمپریسیو اسٹرینتھ — 3 دن", req: "کم از کم 27 MPa" },
      { test: "کمپریسیو اسٹرینتھ — 7 دن", req: "کم از کم 37 MPa" },
      { test: "کمپریسیو اسٹرینتھ — 28 دن", req: "کم از کم 53 MPa" },
      { test: "ابتدائی سیٹنگ ٹائم", req: "کم از کم 30 min" },
      { test: "فائنل سیٹنگ ٹائم", req: "زیادہ سے زیادہ 600 min" },
      { test: "باریکی (بلين)", req: "کم از کم 229 m²/kg" },
      { test: "ساؤنڈنیس (Le-Chatlier)", req: "زیادہ سے زیادہ 10mm" },
    ],
    labCaptions: [
      "لکی سپریم: ٹیسٹ سرٹیفکیٹ جاری کردہ لکی سیمنٹ لمیٹڈ، ڈپٹی جنرل مینیجر (Q.C)، پيزو پلانٹ",
      "بیسٹ وے OPC: سیمنٹ ٹیسٹ رپورٹ جاری کردہ بیسٹ وے سیمنٹ لمیٹڈ، HOD QC، ہٹار پلانٹ",
    ],
    servePre: "ہم کسے",
    serveAccent: "سپلائی کرتے ہیں۔",
    serveSub: "انفرادی تعمیرات سے بڑے منصوبوں تک — ہم ہر اس شخص کو سپلائی کرتے ہیں جو تعمیر کرتا ہے۔",
    servePills: ["کنٹریکٹرز", "بلڈرز", "ہاؤسنگ سوسائٹیز", "رہائشی منصوبے", "کمرشل عمارتیں", "انفراسٹرکچر منصوبے", "ریٹیل ڈیلرز"],
    stepsPre: "آرڈر کیسے",
    stepsAccent: "کریں۔",
    stepsSub: "آسان طریقہ۔ اسی دن ڈیلیوری۔ کوئی جھنجھٹ نہیں۔",
    steps: [
      { title: "غوری ٹریڈرز سے رابطہ کریں", desc: "واٹس ایپ پر اپنی ضرورت بتائیں۔" },
      { title: "مطلوبہ مقدار بتائیں", desc: "بتائیں کہ آپ کو کتنے بورے چاہئیں (کم از کم 100)۔" },
      { title: "پروڈکٹ منتخب کریں", desc: "لکی سپریم یا بیسٹ وے OPC منتخب کریں۔" },
      { title: "ڈیلیوری شیڈول کریں", desc: "ہم آپ کے ڈیلیوری سلاٹ کی تصدیق کرتے ہیں۔" },
      { title: "بروقت سپلائی", desc: "سیمنٹ اسی دن آپ کی دہلیز پر پہنچایا جاتا ہے۔" },
    ],
    stepsCta: "آرڈر شروع کریں",
    contactEyebrow: "آرڈر کے لیے تیار؟",
    contactPre: "لکی اور بیسٹ وے سیمنٹ",
    contactAccent: "آج ہی ڈیلیور کروائیں۔",
    contactBody: "واٹس ایپ پر براہ راست ہم سے بات کریں۔ اپنی ضرورت بتائیں اور ہم چند منٹوں میں جواب دیں گے۔",
    contactCta: "واٹس ایپ پر آرڈر کریں",
    contactVisit: "ہم سے ملیں",
    contactHours: "اوقات",
    contactWrite: "ہمیں لکھیں",
    contactAddress: "07، سٹریٹ 12D، جناح گارڈن، اسلام آباد، 44000، پاکستان",
    contactHoursValue: "پیر تا ہفتہ، صبح 8 بجے تا شام 6 بجے",
    footer1: "© 2026 غوری ٹریڈرز۔ آفیشل لکی اور بیسٹ وے سیمنٹ ڈسٹریبیوٹر — اسلام آباد اور راولپنڈی۔",
    footer2: "پاکستان کے بلڈرز کے لیے بنایا گیا۔",
    seoLinks: [
      { label: "لکی سیمنٹ قیمت", href: "/lucky-cement-price" },
      { label: "بیسٹ وے سیمنٹ اسلام آباد", href: "/bestway-cement-islamabad" },
    ],
    backHome: "→ واپس ہوم پر",
    viewLabReport: "لیب رپورٹ دیکھیں ↗",
    seo: {
      lucky: {
        metaTitle: "اسلام آباد اور راولپنڈی میں لکی سیمنٹ کی قیمت | غوری ٹریڈرز",
        metaDesc: "اسلام آباد اور راولپنڈی میں آج کی لکی سیمنٹ ہول سیل قیمت۔ لکی سپریم گریڈ-53 OPC کے آفیشل ڈسٹریبیوٹر۔ کم از کم آرڈر 100 بورے، اسی دن ڈیلیوری۔",
        eyebrow: "آفیشل لکی سیمنٹ ڈسٹریبیوٹر",
        h1Pre: "لکی سیمنٹ",
        h1Accent: "کی قیمت اسلام آباد اور راولپنڈی میں۔",
        paragraphs: [
          "اسلام آباد یا راولپنڈی میں آج کی لکی سیمنٹ قیمت تلاش کر رہے ہیں؟ پاکستان میں سیمنٹ کے ریٹس مارکیٹ کے مطابق بدلتے رہتے ہیں، اس لیے ہم تازہ ہول سیل ریٹ براہ راست واٹس ایپ پر بتاتے ہیں — کوئی پرانی پرائس لسٹ نہیں۔",
          "اسلام آباد اور راولپنڈی کے آفیشل لکی سیمنٹ ڈسٹریبیوٹر کے طور پر، غوری ٹریڈرز لکی سپریم (گریڈ-53 OPC) ہول سیل ریٹس پر اسی دن ترسیل کے ساتھ فراہم کرتا ہے۔ کم از کم آرڈر 100 بورے ہے اور بڑے منصوبوں کے لیے مکمل ٹرک لوڈ ڈیلیوری بھی دستیاب ہے۔",
        ],
        cards: [
          { title: "آج کا ہول سیل ریٹ", desc: "واٹس ایپ پر اپنی مقدار بتائیں اور چند منٹوں میں لکی سپریم کا تازہ ریٹ حاصل کریں۔" },
          { title: "لیب ٹیسٹڈ کوالٹی", desc: "ہر بیچ PS-232-2008 کے تحت سرٹیفائیڈ: 28 دن میں 60.20 MPa، 344 m²/kg باریکی۔ ٹیسٹ سرٹیفکیٹ درخواست پر دستیاب۔" },
          { title: "اسی دن ڈیلیوری", desc: "اسلام آباد اور راولپنڈی بھر میں ترسیل — براہ راست آپ کی سائٹ، دکان یا سوسائٹی تک۔" },
        ],
        cta: "واٹس ایپ پر آج کی قیمت حاصل کریں",
        reportUrl: "/assets/lucky-supreme-lab.pdf",
      },
      bestway: {
        metaTitle: "بیسٹ وے سیمنٹ اسلام آباد — ہول سیل سپلائر | غوری ٹریڈرز",
        metaDesc: "اسلام آباد اور راولپنڈی میں بیسٹ وے سیمنٹ ہول سیل سپلائر۔ بیسٹ وے OPC ہول سیل ریٹس پر، ہٹار پلانٹ لیب ٹیسٹڈ۔ کم از کم آرڈر 100 بورے۔",
        eyebrow: "بیسٹ وے سیمنٹ ہول سیل سپلائر",
        h1Pre: "بیسٹ وے سیمنٹ",
        h1Accent: "اسلام آباد میں — ہول سیل سپلائی۔",
        paragraphs: [
          "غوری ٹریڈرز اسلام آباد اور راولپنڈی کے لیے بیسٹ وے OPC سیمنٹ کا ہول سیل سپلائر ہے، جس کا ہر بیچ ہٹار پلانٹ میں پاکستان اسٹینڈرڈ PS-232-2008 کے تحت لیب ٹیسٹڈ ہوتا ہے۔",
          "بیسٹ وے OPC 28 دن میں 53.80 MPa مضبوطی دیتا ہے (PS-232-2008 تقاضہ: 53 MPa) اور 318 m²/kg باریکی کے ساتھ — کنٹریکٹرز، بلڈرز اور ہاؤسنگ منصوبوں کے لیے قابلِ اعتماد انتخاب۔ کم از کم آرڈر 100 بورے، اسی دن ترسیل دستیاب۔",
        ],
        cards: [
          { title: "ہول سیل ریٹس", desc: "ڈیلرز، بلڈرز اور ہاؤسنگ سوسائٹیز کے لیے بلک پرائسنگ — واٹس ایپ پر تازہ ریٹ حاصل کریں۔" },
          { title: "سرٹیفائیڈ بیچز", desc: "28 دن میں 53.80 MPa مضبوطی، PS-232-2008 سرٹیفائیڈ۔ ہٹار Q.C ٹیسٹ رپورٹ درخواست پر دستیاب۔" },
          { title: "تیز ترسیل", desc: "اسلام آباد اور راولپنڈی میں اسی دن یا اگلے دن ڈیلیوری۔" },
        ],
        cta: "واٹس ایپ پر ہول سیل کوٹ حاصل کریں",
        reportUrl: "/assets/bestway-lab.jpg",
      },
    },
  },
};

const LangContext = createContext({ lang: "en", t: CONTENT.en, toggle: () => {} });

export const useLang = () => useContext(LangContext);

export function LangProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("gt-lang") || "en");

  useEffect(() => {
    localStorage.setItem("gt-lang", lang);
    document.documentElement.lang = lang;
    document.documentElement.dir = lang === "ur" ? "rtl" : "ltr";
  }, [lang]);

  const toggle = () => setLang((l) => (l === "en" ? "ur" : "en"));

  return <LangContext.Provider value={{ lang, t: CONTENT[lang], toggle }}>{children}</LangContext.Provider>;
}
